// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalContent_root__3-bBd","fullScreen":"ModalContent_fullScreen__dIeif"};